import styled from "styled-components";
import { Modal } from 'antd';
import { injectIntl } from 'react-intl'


export const SModal = styled(injectIntl(Modal))`
    & .ant-spin-nested-loading{
        height: 100%;
    }
    & .ant-spin-container{
        height: 100%;
    }

    & .anticon-close{
        ${props=>props.closable === true ? 'display: none;' : ''}
    }
    
`
